import { Skeleton, Typography } from '@mui/material';

const LoadingHeader = ({ title, subTitle }) => {
  return (
    <div className="col-10">
      <Skeleton animation="wave">
        <Typography variant="h3" fontSize='2rem' color={'#666666'}>
          {title}
        </Typography>
      </Skeleton>
      <Skeleton animation="wave">
        <Typography variant="subtitle1" color={'grey'}>
          {subTitle}
        </Typography>
      </Skeleton>
    </div>
  )
}

export default LoadingHeader;